/**
 * A class to handle cities selection
 **/

var CitiesSelect = function( filters, jstreeEl ){

    this.filters = filters;
    this.jstreeEl = jstreeEl;
    this.countriesFilter = this.filters.find('[data-filter-countries]');
    this.citiesFilter = this.filters.find('[data-filter-cities]');

    this.init();

}

CitiesSelect.prototype.init = function(){
    
    var self = this;
    self.countriesFilter.on('click', function(){
        self.updatefilterCities();
    });

};

CitiesSelect.prototype.updatefilterCities = function(){
    var self = this;
    
    var allCities = self.citiesFilter.find('[data-filter-city]');
    var selectedCountriesEl = self.countriesFilter.find('[data-filter-country][aria-selected="true"]');
    var selectedStatesEL = self.countriesFilter.find('[data-filter-state][aria-selected="true"]');
    
    var selectedCountries = [];
    var selectedStates = [];
    var showCityNumber = 0;
    
    selectedCountriesEl.each(function(){
        selectedCountries.push($(this).data('filter-country'));
    });

    selectedStatesEL.each(function(){
        selectedStates.push($(this).data('filter-state'));
    });

    allCities.each(function(){
        var city = $(this);
        var cityCountry = city.data('city-country');
        var cityState = city.data('city-state');
        
        var isShowCity = 
        (selectedCountries.indexOf(cityCountry) > -1 || selectedStates.indexOf(cityState) > -1)
        || (selectedCountries.length == 0 && selectedStates.length == 0);
        
        if(isShowCity){
            showCityNumber++
            city.show();
            self.jstreeEl.jstree('select_node', city);
        }else{
            showCityNumber--
            city.hide();
            self.jstreeEl.jstree('deselect_node', city);
        }

        if(showCityNumber == allCities.length) {
            self.resetCities();
        }
    });

}

// reset visibility of all cities
CitiesSelect.prototype.resetCities = function(){
    var self = this;
    var allCities = self.citiesFilter.find('[data-filter-city]');
    allCities.each(function(){
        self.jstreeEl.jstree('deselect_node', $(this));
        $(this).show();
    });
}


export default CitiesSelect;